module.exports = "/wp-content/themes/onnit/script/cart/dist/onnitIn30OverrideMobile-ea2b55fa.png";